import { Modal } from 'react-bootstrap';
import SuccessIcon from 'assets/img/popup/Success.svg';
import Button from 'components/base/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome } from '@fortawesome/free-solid-svg-icons';

interface Props {
  show: boolean;
  handleSubmit: () => void;
}

const QuizSubmissionModal = ({ show, handleSubmit }: Props) => {
  return (
    <Modal show={show} onHide={handleSubmit} className="p-0" centered size="sm">
      <Modal.Body className="pt-4 pb-2 px-4">
        <div className="d-flex justify-content-center mb-2">
          <img src={SuccessIcon} width={100} />
        </div>
        <h5 className="text-center fs-6">
          Great Job! <br />
          Quiz Completed!
        </h5>
        <p className="mt-3 text-center">
          Your answers have been submitted for review.
        </p>
        <Button
          variant="primary"
          onClick={handleSubmit}
          className="w-100 mb-2"
          startIcon={<FontAwesomeIcon icon={faHome} className="me-2" />}
        >
          Go to home
        </Button>
      </Modal.Body>
    </Modal>
  );
};

export default QuizSubmissionModal;
